import { storiesOf } from '@storybook/vue';
import { withKnobs, text, boolean, select } from '@storybook/addon-knobs';
import { action } from '@storybook/addon-actions';

import { BUTTON_TYPES } from '#components/@types/button';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Button', () => ({
		template: '<dms-button v-bind="$props" @click="click" />',
		methods: {
			click: action('clicked'),
		},
		props: {
			text: {
				default: text('Text', 'Název buttonu'),
			},
			type: {
				default: select('Typ', BUTTON_TYPES, 'primary'),
			},
			size: {
				default: select('Velikost', ['mini', 'small', 'medium', 'default'], 'mini'),
			},
			icon: {
				default: text('Ikona', 'el-icon-search'),
			},
			round: {
				default: boolean('Zda je zaoblený', true),
			},
			plain: {
				default: boolean('Zda je to jen jednoduché tlačítko', false),
			},
			circle: {
				default: boolean('Zda se jedná o kulaté tlačítko', false),
			},
			disabled: {
				default: boolean('Disabled', false),
			},
		},
	}));
